import { useState } from "react";
import { useSnackbar } from "notistack";
import dayjs from "@lib/dayjs";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { NavLink } from "react-router-dom";
import StarFilledIcon from "@assets/svg/StarFilledIcon";
import { StarIcon } from "lucide-react";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { EnumJobStatus2, JobTypeEnum } from "@utils/constants";


const CandidateRowCard = ({ data }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(data?.isMarkFavorite)
    const [isMarking, setIsMarking] = useState(false)

    const isAspiration = data?.tag === 'Aspiration'

    const handleMarkUnmarkFavorite = async () => {
        // try {
        //   setIsMarking(true)
        //   await markUnmarkFavoriteMatchedJobs({
        //     isMarkFavorite: !isMarkedFavorite,
        //     matchId: data?._id,
        //     tag: data?.tag
        //   })
        //   setIsMarkedFavorite((prev) => !prev)
        // } catch (error) {
        //   enqueueSnackbar(error, { variant: 'error' })
        // } finally {
        //   setIsMarking(false)
        // }
    }

    return (
        <NavLink
            to={'#'}
            // to={`/job-applicant-detail/${data?.jobId}`}
            state={{ item: data }}
            // onClick={onClick}
            className="grid grid-cols-[0.6fr_2fr_0.25fr] gap-28 items-center py-5 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-3">
                <span className="text-xs font-medium text-primary bg-gray-50 rounded-md py-2 px-4 border text-center w-max">
                    {EnumJobStatus2[data?.status]}
                </span>
                <div className="flex gap-3 pt-1 h-full">
                    {
                        data?.profilePic ?
                            <img
                                src={data?.profilePic}
                                className="h-11 w-11 rounded-full" />
                            : <div className="flex h-11 w-11 rounded-full bg-gray-100 border">
                                <span className="font-semibold text-lg text-light-black m-auto">{data?.firstName?.charAt(0)}</span>
                            </div>
                    }
                    <div className="flex flex-col gap-2.5">
                        <span className="font-medium text-light-black text-xs">{data?.refNo}</span>
                        <span className="font-bold text-primary text-xs">{data?.firstName} {data?.lastName}</span>
                        <span className="font-medium text-light-black text-xs">{JobTypeEnum[data?.jobType]}</span>
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-8 h-full w-full">
                <div className="flex flex-col gap-4 flex-1">
                    <span className="text-xs font-bold text-primary text-center">
                        {data?.title}
                    </span>
                    <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-5">
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("hh:mm a")}
                            </span>
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("DD MMM YYYY")}
                            </span>
                        </div>
                        <div className="flex flex-col border border-gray-200 bg-gray-50 rounded-md p-3 gap-1 h-[3.5rem] justify-center">
                            <span className="text-xs font-medium text-primary">
                                Latest Activity : {data?.latestTracker?.status}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-3.5 h-full justify-end pb-3.5">
                    <span className="text-xs text-light-black">Agency</span>
                    <span className="text-xs font-medium text-primary">{data?.agency?.companyName || 'N/A'}</span>
                </div>
            </div>

            <div className="flex flex-col items-center h-full">
                <button
                    onClick={(e) => {
                        e?.preventDefault()
                        e?.stopPropagation()
                        handleMarkUnmarkFavorite()
                    }}
                    className="hover:bg-gray-100 rounded-full p-1.5 mr-4"
                >
                    {
                        isMarking ?
                            <LoadingAnimation color="#2e2e2e" /> :
                            isMarkedFavorite ?
                                <StarFilledIcon className={'h-6 w-6'} />
                                :
                                <StarIcon color="#2e2e2e" strokeWidth={1.5} />
                    }
                </button>
                <div className="flex flex-col h-full justify-end gap-3">
                    <span className="text-xs font-medium text-primary">Matched %</span>
                    <div className="relative">
                        <AnimatedCircleProgress progress={data?.matchingPercentage || 73} />
                    </div>
                </div>
            </div>
        </NavLink>
    );
};

export default CandidateRowCard